<sui-empty-state
  size="page"
  [title]="'page-not-found.not-found-title' | translate"
  [description]="'page-not-found.not-found-message' | translate"
>
  <sui-button variant="secondary" (click)="goHome()">
    {{ ("page-not-found.go-to" | translate) + " " + displayName }}
  </sui-button>
  @if (currentModule !== "analytics" && currentModule !== "auth") {
    <sui-button variant="secondary" (click)="goToMainDashboard()">
      {{ "page-not-found.go-to-analytics-home" | translate }}
    </sui-button>
  }
</sui-empty-state>
<p class="contextual-not-found__module">
  {{ "page-not-found.curren-module" | translate }}
  <strong>{{ displayName }}</strong>
</p>
